import { render, staticRenderFns } from "./FormTestimonials.vue?vue&type=template&id=2854aa11&scoped=true"
import script from "./FormTestimonials.vue?vue&type=script&lang=js"
export * from "./FormTestimonials.vue?vue&type=script&lang=js"
import style0 from "./FormTestimonials.vue?vue&type=style&index=0&id=2854aa11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2854aa11",
  null
  
)

export default component.exports